/**
 * 仪表盘主面板
 * 包含侧边栏分类导航 + 搜索 + 密码条目网格
 */

import React from "react";
import { useStore } from "../store";
import Sidebar from "./Sidebar";
import SearchBar from "./SearchBar";
import ItemCard from "./ItemCard";
import { CATEGORY_NAMES } from "@passkeeper/shared";

interface Props {
  showToast: (msg: string, type: "success" | "error" | "info") => void;
  onAddClick: () => void;
}

export default function Dashboard({ showToast, onAddClick }: Props) {
  const {
    decryptedItems,
    items,
    masterPassword,
    selectedCategory,
    isLoading,
  } = useStore();

  const displayItems = masterPassword ? decryptedItems : items;
  const isEmpty = displayItems.length === 0;
  const isEncryptedList = !masterPassword && items.length > 0;

  return (
    <div className="dashboard">
      <Sidebar onAddClick={onAddClick} />

      <div>
        <SearchBar />

        {selectedCategory !== "all" && (
          <div style={{ marginBottom: 16, fontSize: "0.85rem", color: "#64748b" }}>
            当前筛选：{CATEGORY_NAMES[selectedCategory]} （共 {displayItems.length} 条）
          </div>
        )}

        {isLoading && (
          <div className="empty-state">
            <div className="icon">⏳</div>
            <h3>加载中...</h3>
          </div>
        )}

        {isEncryptedList && !isLoading && (
          <div
            className="card"
            style={{
              padding: 24,
              textAlign: "center",
              marginBottom: 16,
              background: "#fef3c7",
              border: "1px solid #f59e0b",
            }}
          >
            <p style={{ color: "#92400e", fontWeight: 500 }}>
              🔒 已加载 {items.length} 条加密数据
            </p>
            <p style={{ color: "#92400e", fontSize: "0.85rem", marginTop: 4 }}>
              请输入主密码后查看明文
            </p>
            <button
              className="btn btn-primary btn-sm"
              style={{ marginTop: 8 }}
              onClick={() => useStore.getState().decryptItems()}
            >
              🔓 尝试解密
            </button>
          </div>
        )}

        {!isLoading && (
          <>
            {isEmpty ? (
              <div className="empty-state">
                <div className="icon">🔐</div>
                <h3>还没有密码条目</h3>
                <p>点击「添加密码」按钮开始存储你的账号信息</p>
                <p style={{ marginTop: 8, fontSize: "0.85rem" }}>
                  浏览器插件会自动识别并上传注册时的密码，无需手动输入
                </p>
              </div>
            ) : (
              <div className="items-grid">
                {displayItems.map((item) => (
                  <ItemCard
                    key={item.id}
                    item={item}
                    showToast={showToast}
                  />
                ))}
              </div>
            )}

            {!isEmpty && (
              <div
                style={{
                  textAlign: "center",
                  marginTop: 24,
                  color: "#94a3b8",
                  fontSize: "0.8rem",
                }}
              >
                共 {displayItems.length} 条密码记录
              </div>
            )}
          </>
        )}
      </div>
    </div>
  );
}